export const FREE = 'FREE';
export const STARTER = 'STARTER';
export const PROFESSIONAL = 'PROFESSIONAL';
export const ENTERPRISE = 'ENTERPRISE';
export const orderedProductLevels = [FREE, STARTER, PROFESSIONAL, ENTERPRISE];
export const currentOrderedPaidProductLevels = [STARTER, PROFESSIONAL, ENTERPRISE];
export const currentOrderedProductLevels = [FREE, STARTER, PROFESSIONAL, ENTERPRISE];
export const currentLowerProductLevels = [FREE, STARTER, PROFESSIONAL];